(function () {
    'use strict';

    angular.module('swif.parcauto')
    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/parcauto/consumptions/table_view', {
            templateUrl: 'partials/parcauto/consumptions_table_view.html',
            controller: 'ParcAutoConsumptionsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifParcautoService', function (service) {
                    return service.consumption.resolveData();
                }]
            }
        });
    }])
    .controller('ParcAutoConsumptionsController', [
        '$scope', 'swifFrameworkService', 'swifParcautoService', 'data',
        function ($scope, swif, service, data) {
            console.log('init ParcAutoConsumptionsController');
            $scope.data = data;
            $scope.preModal = service.consumption.preModal;
            $scope.preValidate = service.consumption.preValidate;
            $scope.callback = service.consumption.callback;
        }
    ])
    .controller('ParcAutoConsumptionController', [
        '$scope', 'swifFrameworkService', function ($scope, swif) {
            console.log('init ParcAutoConsumptionController');
            $scope.filters = {
                equipment: {fields: ['id', 'name', 'complete_name', 'km', 'serial_badge_fuel']}
            };
            swif.data.addFilter($scope.filters.equipment, 'categ_id.is_vehicle', '=', true);
            $scope.show = {equipment : false};
            $scope.check = {ok_km: true};
            $scope.onEquipmentChange = function (data) {
                $scope.model.km = data.km;
                $scope.check.ok_km = true;
                $scope.model.serial_badge_fuel = data.serial_badge_fuel;
            };
            $scope.onKMChange = function (data) {
                $scope.check.ok_km = $scope.model.km >= data;
            };

        }
    ]);

})();
